import { Container, Grid } from '@mui/material'
import React from 'react'
import { P, SectionHeading, SectionWrapper } from '../../Styles/style'

import launch from "../../../assets/images/launch.png"
import dev from "../../../assets/images/dev.png"
import innove4 from "../../../assets/images/Image 4.png"
import innove5 from "../../../assets/images/Image 5.png"
import innove6 from "../../../assets/images/Image 6.png"
import innove7 from "../../../assets/images/Image 7.png"

import styled from '@emotion/styled'

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "400px")};
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "400px")};
   height:375px;

 } */
`
const FeatureWrapper = styled.div`

height: 375px;
// background-image: linear-gradient(#2B5DFF, #000);
//  background: 
//     linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
//    linear-gradient(to right top, #00d26a, #7b8e1c, #755019, #46241d, #000000);
    
//   border: 1px solid #2B5DFF;
//   border-radius:20px;
// backdrop-filter: blur(13px) !important;
//   padding: 20px;
`
const FeatureWrapperfirst = styled.div`

height: 375px;
// background-image: linear-gradient(#00D26A, #000);
//  background: 
//     linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
//    linear-gradient(to right top, #00d26a, #7b8e1c, #755019, #46241d, #000000);
    
//   border: 1px solid #00D26A;
//   border-radius:20px;
// backdrop-filter: blur(13px) !important;
//   padding: 20px;
`

const SectionSubHeading = styled.h3`
position: absolute;
    top: -30px;
    display: flex;
  font-family: "P-R";
  font-size: ${(props) => (props.fs ? props.fs : "23px")};
  color: ${(props) => props.theme.textPrimary};
  padding: ${(props) => (props.p ? props.p : "20px 0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  /* line-height: ${(props) => (props.lh ? props.lh : "50px")}; */
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  @media screen and (max-width: 1199px) {
    /* font-size: 30px; */
  }
  @media (max-width: 599px) {
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
  @media (max-width: 399px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
  }
`;


const S7_Roadmap = () => {
    return (
        <div>
            <SectionWrapper p="8rem 0 12rem 0" id="roadmap">
                <Container maxWidth="xl">
                    <SectionHeading data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="400"
                        data-aos-duration="500"
                        data-aos-offset="0"
                        style={{textAlign:'left'}}>
                        INFLUENCERS BACKED
                    </SectionHeading>
                    <GridHEading container spacing={3}>

                        <GridImage item xs={12} sm={6} md={3} lg={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="400"
                            data-aos-duration="500">
                            <FeatureWrapperfirst>

                            <JOiningLinks src={innove4} />
                            </FeatureWrapperfirst>


                        </GridImage>
                        <GridImage item xs={12} md={3} sm={6} lg={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <FeatureWrapper>
                            <JOiningLinks src={innove5} />
                                </FeatureWrapper>


                        </GridImage>
                        <GridImage item xs={12} md={3} sm={6} lg={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">
                            <FeatureWrapper>
                            <JOiningLinks src={innove6} />
                               </FeatureWrapper>


                        </GridImage>
                        <GridImage item xs={12} md={3} sm={6} lg={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="600"
                            data-aos-duration="500">
                            <FeatureWrapper>

                                {/* <SectionSubHeading fs="38px"> 
                                
                                 2023 Q4
                                </SectionSubHeading> */}

                                <JOiningLinks src={innove7} />

                                </FeatureWrapper>


                        </GridImage>

                    </GridHEading>
                </Container>

            </SectionWrapper>
        </div>
    )
}

export default S7_Roadmap